var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyTemplates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "My Design/MyTemplates"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.83331 2.66669C3.55717 2.66669 3.33331 2.89054 3.33331 3.16669C3.33331 3.44283 3.55717 3.66669 3.83331 3.66669H11.8333C12.1095 3.66669 12.3333 3.44283 12.3333 3.16669C12.3333 2.89054 12.1095 2.66669 11.8333 2.66669H3.83331ZM2.49998 4.50002C1.85565 4.50002 1.33331 5.02235 1.33331 5.66669V12.3334C1.33331 12.9777 1.85565 13.5 2.49998 13.5H13.1666C13.811 13.5 14.3333 12.9777 14.3333 12.3334V5.66669C14.3333 5.02235 13.811 4.50002 13.1666 4.50002H2.49998ZM2.33331 5.66669C2.33331 5.57464 2.40793 5.50002 2.49998 5.50002H13.1666C13.2587 5.50002 13.3333 5.57464 13.3333 5.66669V12.3334C13.3333 12.4254 13.2587 12.5 13.1666 12.5H2.49998C2.40793 12.5 2.33331 12.4254 2.33331 12.3334V5.66669ZM4.49998 7.33335C4.22384 7.33335 3.99998 7.55721 3.99998 7.83335C3.99998 8.1095 4.22384 8.33335 4.49998 8.33335H11.1666C11.4428 8.33335 11.6666 8.1095 11.6666 7.83335C11.6666 7.55721 11.4428 7.33335 11.1666 7.33335L4.49998 7.33335ZM6.66665 9.83335C6.66665 9.55721 6.8905 9.33335 7.16665 9.33335L11.1666 9.33335C11.4428 9.33335 11.6666 9.55721 11.6666 9.83335C11.6666 10.1095 11.4428 10.3334 11.1666 10.3334H7.16665C6.8905 10.3334 6.66665 10.1095 6.66665 9.83335Z",
    fill: "#2B2B35"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyTemplates);
export default __webpack_public_path__ + "static/media/MyTemplates.dc7f0e5b26ff1c732654541ef219d252.svg";
export { ForwardRef as ReactComponent };